module.exports = "<mz-spinner size=\"small\"></mz-spinner>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/shared/card-spinner/card-spinner/card-spinner.component.html
// module id = ../../../../../src/app/pages/shared/card-spinner/card-spinner/card-spinner.component.html
// module chunks = main